module.exports = {
  context: {
    nodes: [
      {
        id: '64',
        title: 'Catalyst Community Services',
        url: 'http://adjoin.nitro/catalyst-community-services',
        isActive: true
      },
      {
        id: '65',
        title: 'Veterans Community Services',
        url: 'http://adjoin.nitro/veterans-community-services',
        isActive: false
      }
    ]
  }
}
